module.exports = __webpack_public_path__ + "img/alipay.8e979a68.svg";